import { useQuery } from '@apollo/client';
import { createError } from '@common/neo.tax';

import { GetRdExpenseQuery, GetRdExpenseQueryVariables, GET_RD_EXPENSE } from '@neo.tax/shared';

export type RdExpense = GetRdExpenseQuery['getRdExpense'];

export const useRdExpense = (
  rdExpenseId: string | null,
  options?: {
    skip?: boolean;
  },
):
  | {
      rdExpense: null;
      loading: boolean;
    }
  | {
      rdExpense: RdExpense;
      loading: false;
    } => {
  const { skip } = options || {};
  const shouldSkip = skip || !rdExpenseId;
  const { data, error, loading } = useQuery<GetRdExpenseQuery, GetRdExpenseQueryVariables>(
    GET_RD_EXPENSE,
    shouldSkip ? { skip: true } : { variables: { rdExpenseId } },
  );

  if (loading) {
    return { rdExpense: null, loading: true };
  }
  if (error) {
    throw error;
  }
  if (!data && !shouldSkip) {
    throw createError('MissingRdExpense', `Failed to load RdExpense with id ${rdExpenseId}`);
  }

  return {
    rdExpense: data?.getRdExpense || null,
    loading,
  };
};
